module.exports = __webpack_public_path__ + "img/ie.516b6a83.svg";